// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.legendLabel_vpeCK {
  margin-left : 12px;
  width : 120px;
  white-space : nowrap;
  overflow : hidden;
  text-overflow : ellipsis;
  font-weight : 600;
}

.legend_QND2g {
  padding: 10px;
}

.legend_QND2g > div:first-child {
  margin-top: 16px !important;
  margin-bottom: 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/plugins/dataViewers/lineStageGanttChart/occupancyGraph/ChartLegend.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B","sourcesContent":[".legendLabel {\n  margin-left : 12px;\n  width : 120px;\n  white-space : nowrap;\n  overflow : hidden;\n  text-overflow : ellipsis;\n  font-weight : 600;\n}\n\n.legend {\n  padding: 10px;\n}\n\n.legend > div:first-child {\n  margin-top: 16px !important;\n  margin-bottom: 0px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"legendLabel": `legendLabel_vpeCK`,
	"legend": `legend_QND2g`
};
export default ___CSS_LOADER_EXPORT___;
